import { useState } from "react";
import { List, Card, Typography, Space, Button } from "antd";
import { BarChartOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "../../utils/formatDateTime";
import "../Dokument/DokumentCardsKorisnik.css";
import "../Dokument/DokumentCards.css";

const { Text } = Typography;

function AnketaCards({ ankete, onDeleteClick }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentAnkete = ankete.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(ankete.length / itemsPerPage);

  const handleClickAnketa = (anketaId) => {
    navigate(`/zaposleni/anketa/${anketaId}`);
  };

  return (
    <List
      grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 4, xl: 4, xxl: 4 }}
      dataSource={currentAnkete}
      locale={{ emptyText: "Nema dostupnih anketa." }}
      renderItem={(anketa, index) => {
        const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
        const backgroundColor = colors[index % colors.length];

        return (
          <List.Item onClick={() => handleClickAnketa(anketa.id)}>
            <div className="document-cards-zaposleni">
              <Card
                hoverable
                cover={
                  <div
                    className="dokument-card-cover"
                    style={{ backgroundColor }}
                  >
                    <BarChartOutlined
                      style={{ fontSize: 48, color: "#2b494b" }}
                    />
                  </div>
                }
              >
                <div className="dokument-card-title">{anketa.naziv}</div>
                <Space
                  className="document-card-footer-zaposleni"
                  align="center"
                  size={0}
                >
                  <Text type="secondary">
                    Kreirano: {formatDateTime(anketa.datumKreiranja)}
                  </Text>
                  <Text type="secondary">
                    Važi do: {formatDateTime(anketa.datumVazenja)}
                  </Text>
                  <Button
                    key="delete"
                    icon={<DeleteOutlined />}
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteClick(anketa.id);
                    }}
                    className="card-action-button"
                    type="text"
                  />
                </Space>
              </Card>
            </div>
          </List.Item>
        );
      }}
    >
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Prethodna
          </button>

          <span>
            Stranica {currentPage} od {totalPages}
          </span>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Sljedeća
          </button>
        </div>
      )}
    </List>
  );
}

export default AnketaCards;
